import http from "./apiServices"

export const getDashboard = () => {
  return http.get("dashboard")
}
